"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CultureProvider = void 0;
var _culture = require("@ori/culture");
var _i18n = require("@ori/i18n");
var _jsxRuntime = require("react/jsx-runtime");
const CultureProvider = ({
  cultureSettings,
  useLegacyKendoCulture,
  children
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.ServerCultureProvider, {
    cultureSettings: cultureSettings,
    language: language,
    renderLegacyCulture: useLegacyKendoCulture,
    children: children
  });
};
exports.CultureProvider = CultureProvider;
